import loadable from '@loadable/component';

export const ProductTabProperties = loadable(
  () =>
    import(
      /* webpackChunkName: "product-tab-properties" */ './product-tab-properties'
    )
);
